"use strict";
/*
 * This file is released under the MIT license.
 * Copyright (c) 2023, Mike Lischke
 *
 * See LICENSE file for more info.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockSymbol = void 0;
const ScopedSymbol_1 = require("./ScopedSymbol");
class BlockSymbol extends ScopedSymbol_1.ScopedSymbol {
}
exports.BlockSymbol = BlockSymbol;
//# sourceMappingURL=BlockSymbol.js.map